import http from './http'
import qs from 'qs'

export default {
    all(query = {}) {
        return http.get(`mediosinformacion?${qs.stringify(query)}`)
    }
}